import Reveal from '@/components/feature/Reveal';
import { SectionWrapper, SectionHeading } from '@/components/feature/SectionHeading';

export interface BulletCard {
  icon: string;
  title: string;
  bullets: string[];
}

interface BulletCardsProps {
  eyebrow: string;
  title: string;
  description?: string;
  cards: BulletCard[];
  columns?: 3 | 4;
  className?: string;
}

export default function BulletCards({
  eyebrow,
  title,
  description,
  cards,
  columns = 3,
  className = '',
}: BulletCardsProps) {
  const gridClass =
    columns === 4
      ? 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4'
      : 'grid-cols-1 md:grid-cols-3';

  return (
    <SectionWrapper className={className}>
      <SectionHeading eyebrow={eyebrow} title={title} description={description} />
      <div className={`mt-12 md:mt-16 grid ${gridClass} gap-6`}>
        {cards.map((c, i) => (
          <Reveal key={c.title} delay={i * 60}>
            <div className="bg-[#1a1a2e] border border-[#2a2a3e] rounded-2xl p-8 h-full group transition-all duration-300 hover:-translate-y-1 hover:border-[#7c3aed] hover:shadow-[0_0_20px_rgba(124,58,237,0.2)]">
              <div className="icon-outline">
                <i className={c.icon}></i>
              </div>
              <h3 className="mt-6 text-xl font-extrabold text-white">{c.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {c.bullets.map((b) => (
                  <li key={b} className="flex items-start gap-2.5 text-sm text-[#a0a0b0] leading-relaxed">
                    <span className="w-1.5 h-1.5 mt-2 rounded-full bg-[#a855f7] shrink-0"></span>
                    {b}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        ))}
      </div>
    </SectionWrapper>
  );
}